<template>
  <form method="get" class="bg-white rounded-xl m-auto w-1/2 content-center py-4" @submit.prevent="submitForm">
    <div class="justify-center text-center">
      <h1 class="text-2xl text-pdsPrimaryColor font-bold mx-4 my-4">Wachtwoord resetten</h1>
    </div>

    <p class="mx-8 my-4">
      Vul hieronder uw gebruikersnaam, e-mailadres en een veiligheidscode in. We sturen dan binnen enkele minuten een
      e-mail waarmee een nieuw wachtwoord kan worden aangemaakt.
    </p>
    <div class="grid grid-rows gap-4 justify-items-center">
      <div class="w-2/3">
        <v-input-group-simple-2
          id="Username"
          v-model:value="resetPasswordDetails.Username"
          :rules="{
            required: true
          }"
          class="input-password"
          placeholder="Gebruikersnaam"
          type="text"
          label="Gebruikersnaam"
          @input="saveInput($event)"
        />
      </div>
      <div class="w-2/3">
        <v-input-group-simple-2
          id="Emailaddress"
          v-model:value="resetPasswordDetails.Emailaddress"
          :rules="{
            required: true,
            isEmail: true
          }"
          class="input-password"
          placeholder="E-mail"
          type="text"
          label="E-mail"
          @input="saveInput($event)"
        />
      </div>
      <div class="w-2/3">
        <v-input-group-simple-2
          id="Securitycode"
          v-model:value="resetPasswordDetails.Securitycode"
          :rules="{
            required: true
          }"
          class="input-password"
          placeholder="Veiligheidscode"
          :show-tooltip="true"
          tooltip-text="Deze veiligheidscode wordt ter controle opnieuw gevraagd bij het invullen van een nieuw wachtwoord. De code mag zelf gekozen worden. Onthoud deze goed."
          type="text"
          label="Veiligheidscode"
          @input="saveInput($event)"
        />
      </div>
    </div>
    <div class="justify-items-center">
      <button
        type="submit"
        class="flex justify-center py-2 px-2 md:px-4 shadow-sm text-xs md:text-sm lg:text-sm font-medium text-white bg-cta rounded-full hover:bg-primary-default/50 mt-6 mb-4"
      >
        <span class="">Wachtwoord herstellen</span>
      </button>
    </div>
  </form>
</template>

<script>
import router from '@/router';
import { useStore } from 'vuex';
import { useForm } from 'vee-validate';
import { $validateAllComponents } from '@/validate/index.js';
import { ref, getCurrentInstance, onMounted } from 'vue';

export default {
  name: 'VResetPassword',
  components: {},
  setup() {
    const instance = getCurrentInstance();
    const $emitter = instance.appContext.config.globalProperties.$emitter;
    const store = useStore();
    const submitResetPasswordForm = (data) => store.dispatch('login/submitResetPasswordForm', data);
    const { validate } = useForm();
    let resetPasswordDetails = ref({
      Username: undefined,
      Emailaddress: undefined,
      Securitycode: undefined
    });
    let formSubmitted = ref(false);

    const submitForm = () => {
      $validateAllComponents(instance.proxy).then((validated) => {
        if (validated) {
          formSubmitted.value = true;
          submitResetPasswordForm(resetPasswordDetails.value)
            .then(() => {
              // Submission successful
              $emitter.emit('alert', {
                message: 'Uw wachtwoord is gereset. U ontvangt een e-mail met instructies.',
                type: 0,
                delay: 5000
              });
              router.push({ path: '/' });
            })
            .catch(() => {
              // Submission failed or denied
              $emitter.emit('alert', { message: 'Uw wachtwoord kon niet worden gereset.', type: 3 });
              formSubmitted.value = false;
            });
        }
      });
    };

    const saveInput = (event) => {
      resetPasswordDetails.value[event.target.id] = event.target.value;
    };

    onMounted(() => {});

    return {
      submitResetPasswordForm,
      validate,
      resetPasswordDetails,
      formSubmitted,
      saveInput,
      submitForm
    };
  },
  created() {
    this.$parent.$parent.pageTitle = 'Wachtwoord vergeten';
    this.$parent.$parent.navigationBackText = 'Terug naar inloggen';
  }
};
</script>
